module.exports = __webpack_public_path__ + "static/img/manual2.d57931e0.png";